import { gantt } from "@dhx/gantt";
import { Component } from "react";
import { combineReducers } from "@reduxjs/toolkit";
import basicDetailsReducer from "@slices/project-details.slice";
import dialogReducer from "@slices/dialog.slice";
import authReducer from "@slices/auth.slice";
import configReducer from "@slices/config.slice";
import taskReducer from "@src/views/project-tasks/slices/task.slice";
import momReducer from "@slices/mom.slice";
import usersReducer from "@src/views/users/slices/users.slice";
import escReducer from "@src/views/esc/slices/esc.slice";
import customerReducer from "@src/views/customers/slices/customer.slice";
import departmentReducer from "@src/views/departments/slices/departments.slice";
import documentReducer from "@src/views/documents/slices/document.slice";
import mileStoneReducer from "@src/views/mile-stone/slice/mile-stone.slice";
import eventReducer from "@src/views/events/slice/events.slice";
import overviewReducer from "@src/views/project-dashboard/slices/overview.slice";
import brokerReducer from "@slices/broker.slice";
import npmsTemplateSlice from "@src/views/master-data-management/components/npms-template/slices/npms.slice";
import eciTemplateSlice from "@src/views/master-data-management/components/eci-template/slices/eci.slice";
import userGroupsReducer from "@src/views/users/slices/user-group.slice";
import userRoleReducer from "@src/redux/slices/user-role.slice";
import dashboardReducer from "@slices/dashboard.slice";
import hodStatusReducer from "@src/views/project-plan/slices/hod-status.slice";
import customProjectReducer from "@src/views/create-project/custom/slices/custom.slice";
import plantReducer from "@src/views/plant/slices/plant.slice";
import productReducer from "@src/views/product/slice/product.slice";
import categoryReducer from "@src/views/category/slices/category.slice";
import projectUserReducer from "@src/views/project-users/slice/project-users.slice";
import deliveryLocationReducer from "@src/views/delivery-location/slices/delivery-location.slice";
import draftReducer from "@src/views/create-project/drafts/slices/draft.slice";
import mdmMilestoneReducer from "@src/views/master-data-management/components/mdm-milestone/slice/mdm-milestone.slice";
import mdmEventReducer from "@src/views/master-data-management/components/mdm-events/slice/mdm-events.slice";
import revisionListReducer from "@src/views/project-revision/slices/project-revision.slice";
import projectListReducer from "@src/views/project-list/slices/project-list.slice";
import notificationSlice from "@src/views/notification/slices/notification.slice";
import ganttReducer from "@src/views/gantt-chart/slice/gantt.slice";
import holidaysReducer from "@src/views/holiday/slice/holiday-slice";
import dashboardSlice from "@slices/dashboard.slice";
import npmsDashboardSlice from "@src/views/dashboard/slices/npms-dashboard.slice";
import customDashboardSlice from "@src/views/dashboard/slices/custom-dashboard.slice";
import myProjectsSlice from "@src/views/dashboard/slices/my-projects.slice";
import myTaskSlice from "@src/views/dashboard/slices/my-task.slice";
import closeProjectStatusSlice from "@src/views/project-plan/slices/project-close.slice"
import RemarksSlice from "@src/views/create-task-test/slices/task-service"
import TaskRevisionSlice from "@src/views/create-task-copy/slices/task-revision.slice"
const rootReducer = combineReducers({
  dialogs: dialogReducer,
  auth: authReducer,
  config: configReducer,
  broker: brokerReducer,
  task: taskReducer,
  mom: momReducer,
  users: usersReducer,
  basicDetails: basicDetailsReducer,
  esc: escReducer,
  customer: customerReducer,
  department: departmentReducer,
  mileStone: mileStoneReducer,
  events: eventReducer,
  document: documentReducer,
  overview: overviewReducer,
  userGroups: userGroupsReducer,
  userRole: userRoleReducer,
  hodStatus: hodStatusReducer,
  npmsTemplate: npmsTemplateSlice,
  eciTemplate: eciTemplateSlice,
  dashboard: dashboardReducer,
  customProject: customProjectReducer,
  plant: plantReducer,
  product: productReducer,
  category: categoryReducer,
  projectUsers: projectUserReducer,
  draft: draftReducer,
  deliveryLocation: deliveryLocationReducer,
  mdmMilestone: mdmMilestoneReducer,
  gantt: ganttReducer,
  mdmEvent: mdmEventReducer,
  projectList:projectListReducer,
  revisionList : revisionListReducer,
    notification: notificationSlice,
    npmsDashboard: npmsDashboardSlice,
    customDashboard: customDashboardSlice,
    myProjectDashboard: myProjectsSlice,
    myTaskList: myTaskSlice,
  holidays: holidaysReducer,
  projectStatus:closeProjectStatusSlice,
  remarks:RemarksSlice,
  taskRevision:TaskRevisionSlice,
});

export default rootReducer;
